import { render, staticRenderFns } from "./MyBookRespite.vue?vue&type=template&id=3acd37c1"
import script from "./MyBookRespite.vue?vue&type=script&lang=js"
export * from "./MyBookRespite.vue?vue&type=script&lang=js"
import style0 from "./MyBookRespite.vue?vue&type=style&index=0&id=3acd37c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports